// GET RESOURCES DATA
export const GET_RESOURCES_DATA = "/listAllResource";
export const VALIDATE_RESOURCES_DATA = "/getResourceShareLink";
export const SYNC_FILE = "/admin/syncFile";

